<template>
  <div>
    <PageHead title="我发起的整改任务"></PageHead>
    <div class="oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <a-button
          type="link"
          slot="orgCount"
          :disabled="text == 0"
          slot-scope="text, record"
          @click="lookConT(record.orgCountNames)"
        >
          {{ text }}
        </a-button>
        <span slot="remindMethod" slot-scope="text">
          {{ text == 1 ? "是" : "否" }}
        </span>
        <a-button
          type="link"
          slot="yesCount"
          :disabled="text == 0"
          slot-scope="text, record"
          @click="lookConT(record.yesCountNames)"
        >
          {{ text }}
        </a-button>
        <a-button
          type="link"
          slot="noCount"
          :disabled="text == 0"
          slot-scope="text, record"
          @click="lookConT(record.noCountNames)"
        >
          {{ text }}
        </a-button>
        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="record.yesCount == 0"
            type="link"
            class="btn-link"
            @click="add(record.id)"
          >
            撤回
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    scopedSlots: { customRender: "index" },
    width: 80,
  },

  {
    title: "整改任务发起时间",
    dataIndex: "startTime",
    key: "startTime",
    ellipsis: true,
  },
  {
    title: "执行单位",
    dataIndex: "orgCount",
    key: "orgCount",
    scopedSlots: { customRender: "orgCount" },
    ellipsis: true,
  },
  {
    title: "任务到期时间",
    dataIndex: "endTime",
    key: "endTime",
    ellipsis: true,
  },

  {
    title: "是否发系统提醒",
    dataIndex: "remindMethod",
    key: "remindMethod",
    scopedSlots: { customRender: "remindMethod" },
    ellipsis: true,
  },
  {
    title: "已填写",
    dataIndex: "yesCount",
    key: "yesCount",
    scopedSlots: { customRender: "yesCount" },
    ellipsis: true,
  },
  {
    title: "未填写",
    dataIndex: "noCount",
    key: "noCount",
    scopedSlots: { customRender: "noCount" },
    ellipsis: true,
  },

  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 80,
  },
];
import { taskGetUserList, taskDelete } from "./api/api";
export default {
  data() {
    return {
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    // 查看部门名称
    lookConT(list) {
      this.$warning({
        width: "600px",
        title: list.map((item) => {
          return <div style="margin-bottom:5px">{item}</div>;
        }),
      });
    },
    add(id) {
      this.$confirm({
        title: "确定撤回吗?",
        okType: "danger",
        onOk: () => {
          taskDelete({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("撤回成功");
              this.page = 1;
              this.load();
            }
          });
        },
      });
    },
    // 拉取列表
    load() {
      this.loading = true;
      let params = {};
      params.page = this.page;
      params.size = this.size;
      taskGetUserList(params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    pageChange(pageber) {
      this.page = pageber;
      this.load();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/standingBook/IInitiatedTheMission.vue